import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { StorageService } from './storage.service';

const ACCESS_TOKEN = 'accessToken';
const REFRESH_TOKEN = 'refreshToken';
const USER_DATA = 'userData';

@Injectable({
  providedIn: 'root',
})
export class DataStorageService extends StorageService {
  logout(): void {
    this.remove(ACCESS_TOKEN);
    this.remove(REFRESH_TOKEN);
    this.remove(USER_DATA);
  }

  setUserData(data: any): void {
    this.set(USER_DATA, data);
  }

  clearUserData(): void {
    this.remove(USER_DATA);
  }

  getUserData(): any | undefined {
    return this.get<any>(USER_DATA);
  }

  onUserDataChanged(): Observable<any | undefined> {
    return this.watch(USER_DATA) ?? EMPTY;
  }

  getAccessToken(): string | undefined {
    return this.get<string>(ACCESS_TOKEN);
  }

  getRefreshToken(): string | undefined {
    return this.get<string>(REFRESH_TOKEN);
  }

  setTokens(accessToken: string | undefined, refreshToken?: string | undefined): void {
    this.set(ACCESS_TOKEN, accessToken);
    this.set(REFRESH_TOKEN, refreshToken);
  }

  setAccessToken(accessToken: string | undefined): void {
    this.set(ACCESS_TOKEN, accessToken);
  }

  onAccessTokenChanged(): Observable<string | undefined> {
    return this.watch(ACCESS_TOKEN) ?? EMPTY;
  }
}
